/**
 * Returns whether the current environment equals `env`.
 *
 * Defaults to `'production'` when `process.env.NODE_ENV` is unreadable
 * (e.g. in the browser where `process` is not shimmed), so that
 * dev-only code paths stay disabled in production by default.
 *
 * Kept in step with `src/shared/utils/isNodeEnv.ts`.
 *
 * @param env
 */
export function isNodeEnv(env: string) {
  let current: string | undefined;
  try {
    // Bare read, no `typeof process` guard: webpack/rspack's `optimization.nodeEnv`
    // substitutes this exact expression for a literal, so client builds still see
    // their real NODE_ENV — which is what keeps joykit's dev-time prop warnings
    // alive in development. Un-substituted, the reference throws ReferenceError.
    current = process.env.NODE_ENV;
  } catch {
    current = undefined;
  }
  return (current || 'production') === env;
}
